<script setup lang="ts">
import TenantSwitchDropdown from "@/components/TenantSwitchDropdown.vue";
import ProfileDropdown from "@/components/ProfileDropdown.vue";

const props = defineProps<{
  isSidebarOpen: boolean;
}>();

const emit = defineEmits(["@openMenu"]);

function toggleOpen() {
  emit("@openMenu", !props.isSidebarOpen);
}
</script>

<template>
  <div class="topbar">
    <div :class="['burger', { open: props.isSidebarOpen }]" @click="toggleOpen">
      <span class="bar" />
      <span class="bar" />
      <span class="bar" />
    </div>

    <img class="logo tab" src="/src/assets/img/mobius.svg" alt="Gozynta Mobius logo">
    <img class="logo mob" src="/src/assets/img/mobius-logomark.svg" alt="Gozynta Mobius logomark">

    <div class="dropdown-controls">
      <TenantSwitchDropdown />
      <ProfileDropdown />
    </div>
  </div>
</template>

<style scoped lang="scss">
.topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
  padding: 10px 20px;
  box-shadow: map.get(v.$shadow, "md");
  display: flex;
  align-items: center;
  gap: 30px;
  @media (max-width: map.get(v.$breakpoints, "sm")) {
    gap: 15px;
    padding: 10px;
  }
  .burger {
    display: none;
    @media (max-width: map.get(v.$breakpoints, "md")) {
      flex-shrink: 0;
      width: 35px;
      height: 25px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      cursor: pointer;
      z-index: 2;
      .bar {
        width: 100%;
        height: 2px;
        background-color: map.get(v.$gray, "700");
        transition: .2s;
        border-radius: map.get(v.$border-radius, "max");
        &:nth-child(2) {
          width: 70%;
        }
      }
      &.open {
        .bar {
          &:nth-child(1) {
            transform: translateY(11px) rotate(45deg);
          }
          &:nth-child(2) {
            opacity: 0;
          }
          &:nth-child(3) {
            transform: translateY(-11px) rotate(-45deg);
          }
        }
      }
    }
  }
  img.logo {
    height: 35px;
    &.tab {
      @media(max-width: map.get(v.$breakpoints, "md")) {
        display: none;
      }
    }
    &.mob {
      @media(min-width: calc(map.get(v.$breakpoints, "md") + 1px)) {
        display: none;
      }
    }
  }
  .dropdown-controls {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }
}
</style>